import * as React from 'react';
import { clsx } from 'clsx';

import { CollapsedBlock } from '../CollapsedBlock';
import { trackOpenNewbuildingDescription } from './tracking';
import * as styles from './styles.css';

interface IDeveloperDescriptionProps {
  description: string;
}

export function DeveloperDescription({ description }: IDeveloperDescriptionProps) {
  const [opened, setOpened] = React.useState(false);
  const onChangeOpen = React.useCallback(
    (isOpen: boolean) => {
      setOpened(isOpen);
      if (isOpen) {
        trackOpenNewbuildingDescription();
      }
    },
    [setOpened],
  );

  return (
    <CollapsedBlock opened={opened} onChangeOpen={onChangeOpen} collapsedHeight={154}>
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description }}
        className={clsx(styles['text'], opened && styles['formatted'])}
      />
    </CollapsedBlock>
  );
}
